import { ColDef } from 'ag-grid-community';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import { Dispatch, RefObject, SetStateAction } from 'react';
import {
  ComposedTableDataType,
  TableHeaderFiltersType,
  TotalsFooterType
} from 'components/ComposedTable/types';

export type ExportTableDataType = {
  isSelectedForExport: string;
  [x: string]: any;
};

export type ExportOrArchiveType<
  TData extends ComposedTableDataType,
  TExportData extends ComposedTableDataType
> = {
  exportData?: TExportData[];
  isExportDataFetching?: boolean;
  getCSVDocument?: (data: TExportData[]) => string;
  getExcelDocument?: (data: TExportData[]) => Blob;
  getPDFDocument?: (data: TExportData[]) => Promise<Blob | undefined>;
  rowModelType?: AgGridReactProps['rowModelType'];
  setIsExportDataQueryEnabled?: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  downloadDialogTitle?: string;
  onClose: () => void;
  gridRef?: RefObject<AgGridReact<TData>>;
  totalsInFooter?: TotalsFooterType;
  tableHeaderFilters?: TableHeaderFiltersType;
  columnDefs: ColDef<TData, any>[] | null | undefined;
};

export enum FileType {
  XLS = 'xls',
  CSV = 'csv',
  PDF = 'pdf'
}

export type ArchiveDataResponseType = {
  successMessage: string;
  errorMessage: string;
};

export type ArchiveDataRequestPayloadType = FormData;

export type ArchiveDataType<TData extends ComposedTableDataType> = {
  gridRef: RefObject<AgGridReact<TData>>;
  fileType: string;
  headerContent: string;
  footerContent: string;
  exportCols?: (string | undefined)[];
};
